import { AdTypes } from '@bingads-webui-campaign-react/campaign-onboarding-v2';

export const STEP_PATHS = {
  CAMPAIGN_SETTINGS: 'CAMPAIGN_SETTINGS',
  BUDGET_AND_BIDS: 'BUDGET_AND_BIDS',
  TARGET_SETTINGS: 'TARGET_SETTINGS',
  AD_GROUP_SETTINGS: 'AD_GROUP_SETTINGS',
  SUMMARY: 'SUMMARY',
};

export const FLOWS = {
  SHOPPING_AUDIENCE: 'SHOPPING_AUDIENCE',
  SHOPPING_SEARCH: 'SHOPPING_SEARCH',
};

export const AD_TYPES_TO_FLOWS = {
  [AdTypes.ShoppingAudience]: FLOWS.SHOPPING_AUDIENCE,
  [AdTypes.AudienceAndSearch]: FLOWS.SHOPPING_SEARCH,
};

export const PLACEHOLDER_ID = {
  CampaignNegativeReferenceId: -11,
};

export const CREATE_SCENARIO = {
  CREATE_CAMPAIGN: 'create_campaign',
  UPDATE_CAMPAIGN: 'update_campaign',
  UPDATE_ADGROUP: 'update_adGroup',
};
